import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface StatsProps {
  title: string
  titleEn?: string
  items: Array<{
    value: string
    label: string
    labelEn?: string
    description?: string
    descriptionEn?: string
  }>
}

export default function StatsBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as StatsProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || (p.items && p.items.length > 0)
  if (!hasContent) return null

  return (
    <section className="py-20 px-6 bg-gray-50/50">
      <div className="max-w-6xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {(p.items || []).map((item, i) => (
            <div key={i} className="text-center p-6 rounded-2xl bg-white border border-black/[0.04]">
              <div className="text-3xl font-bold mb-1" style={{ color: branding.primaryColor }}>{item.value}</div>
              <div className="text-xs font-medium mb-1" style={{ color: branding.secondaryColor }}>
                {lang === 'en' && item.labelEn ? item.labelEn : item.label}
              </div>
              {item.description && (
                <p className="text-[10px] text-gray-400">
                  {lang === 'en' && item.descriptionEn ? item.descriptionEn : item.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
